import { useTranslate } from "@similarweb/i18n-provider";
import { Badge } from "@similarweb/ui-components";
import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type SignalTemplate from "app/pages/sales-intelligence/sub-modules/signals/models/templates/SignalTemplate";
import type { ComponentType, ReactElement } from "react";

type ConsumerProps = {
    template: Readonly<SignalTemplate<SignalFilters>>;
    tag?: ReactElement;
};

type HocProps = { template: Readonly<SignalTemplate<SignalFilters>> };

const withSignalLifeCycleTag = (Component: ComponentType<ConsumerProps>) =>
    function WrappedWithSignalLifeCycleTag(props: HocProps) {
        const { translate } = useTranslate();

        const getTagElement = (): ReactElement | undefined => {
            if (props.template.signalLifecycleState === "beta") {
                return (
                    <span style={{ marginLeft: 8 }}>
                        <Badge type="beta" />
                    </span>
                );
            }

            if (props.template.signalLifecycleState === "updated") {
                return (
                    <span style={{ marginLeft: 8 }}>
                        <Badge type="new">{translate("si.common.updated")}</Badge>
                    </span>
                );
            }

            if (props.template.signalLifecycleState === "post-beta") {return <span style={{ marginLeft: 8 }}><Badge type="new" /></span>;}

            return undefined;
        };

        return (
            <Component
                {...props}
                tag={getTagElement()}
            />
        );
    };

export default withSignalLifeCycleTag;
